import React, {ReactElement} from 'react';
import {Button, ButtonProps} from '@material-ui/core';
import './ButtonStyle.scss';

const SecondaryButton: React.FC<ButtonProps> = (props): ReactElement => {
  const {children, className, ...rest} = props;
  return (
    <Button
      color="primary"
      variant="outlined"
      className={['button-base secondary', className].join(' ')}
      {...rest}>
      {children}
    </Button>
  );
};

export default SecondaryButton;
